import { createAction, props, createReducer, on } from '@ngrx/store';
import { D2dBookingInitState, IBooking } from '../models/d2d-booking.interface';

// Action definitions using createAction
export const updateAvailableProducts = createAction(
  '[D2dBooking] Update Available Products',
  props<{ payload: any }>()
);

export const updateBookingCount = createAction(
  '[D2dBooking] Update Booking Count',
  props<{ payload: number }>()
);

export const incrementBookingCount = createAction(
  '[D2dBooking] Increment Booking Count'
);

export const updateAddBookingCount = createAction(
  '[D2dBooking] Update Add Booking Count',
  props<{ payload: number }>()
);

export const saveFormData = createAction(
  '[D2dBooking] Save Form Data',
  props<{ payload: any }>()
);

export const saveBookingDetails = createAction(
  '[D2dBooking] Save Booking Details',
  props<{ payload: { bookingType: string; flightReducer: any; bookingReducer: any; currentBookingReducer: any; priceReducer: { price: any; amendPaymentConfirmed: boolean }; timeslotReducer: any; flightFinderReducer: any; hubDropReducer: any; isCompleted: boolean } }>()
);

export const updateInboundBookingObject = createAction(
  '[D2dBooking] Update Inbound Booking Object',
  props<{ payload: any }>()
);

export const updateOutboundBookingObject = createAction(
  '[D2dBooking] Update Outbound Booking Object',
  props<{ payload: any }>()
);

export const updateInboundAddress = createAction(
  '[D2dBooking] Update Inbound Address',
  props<{ payload: any }>()
);

export const updateOutboundAddress = createAction(
  '[D2dBooking] Update Outbound Address',
  props<{ payload: any }>()
);

export const updateIsBookingComplete = createAction(
  '[D2dBooking] Update Is Booking Complete',
  props<{ payload: { bookingType: string, isCompleted: boolean } }>()
);

export const savePromoCode = createAction(
  '[D2dBooking] Save Promo Code',
  props<{ payload: any }>()
);

export const saveOutboundPrice = createAction(
  '[D2dBooking] Save Outbound Price',
  props<{ payload: string }>()
);

export const saveInboundPrice = createAction(
  '[D2dBooking] Save Inbound Price',
  props<{ payload: string }>()
);

export const selectedServiceType = createAction(
  '[D2dBooking] Selected Service Type',
  props<{ payload: string }>()
);

export const sessionServiceType = createAction(
  '[D2dBooking] Session Service Type',
  props<{ payload: string }>()
);

export const applePayToken = createAction(
  '[D2dBooking] Apple Pay Token',
  props<{ payload: string }>()
);

export const googlePayToken = createAction(
  '[D2dBooking] Google Pay Token',
  props<{ payload: string }>()
);

export const updateSessionRequest = createAction(
  '[D2dBooking] Update Session Request',
  props<{ payload: { hasSession: boolean, request: any } }>()
);

export const canAvailD2d = createAction(
  '[D2dBooking] Can Avail D2D',
  props<{ payload: boolean }>()
);

export const paymentWithSavedCard = createAction(
  '[D2dBooking] Payment With Saved Card',
  props<{ payload: boolean }>()
);

export const cardType = createAction(
  '[D2dBooking] Card Type',
  props<{ payload: string }>()
);

export const promoDetails = createAction(
  '[D2dBooking] Promo Details',
  props<{ payload: any }>()
);

export const updateCurrentBookingProduct = createAction(
  '[D2dBooking] Update Current Booking Product',
  props<{ payload: string }>()
);

export const refreshD2dBooking = createAction(
  '[D2dBooking] Refresh D2D Booking',
  props<{ payload: any }>()
);

export const resetD2dState = createAction(
  '[D2dBooking] Reset D2D State'
);

export const paymentType = createAction(
  '[D2dBooking] Payment Type',
  props<{ payload: number }>()
);

export const savePostOfficePrice = createAction(
  '[D2dBooking] Save Post Office Price',
  props<{ payload: string }>()
);

// Initial state
const initState: D2dBookingInitState = {
  flightDetails: {
    flightProducts: {
      abc: false,
      ccd: false,
      sds: false,
      isDomesticABC: false
    }
  },
  bookingCount: 0,
  addBookingCount: 0,
  inboundBooking: {} as IBooking,
  outboundBooking: {} as IBooking,
  formData: null,
  promoCode: [],
  outboundPrice: '',
  inboundPrice: '',
  departurePostOfficePrice: '',
  userSelectedServicetype: '',
  hasSession: false,
  sessionFlightStatusRequest: {},
  paymentType: 2,
  applePayToken: null,
  googlePayToken: null,
  canAvailD2d: true,
  paymentWithSavedCard: false,
  cardType: '',
  promoDetails: null,
  sessionServiceType: '',
  currentBookingProduct: ''
};

// Reducer using createReducer and on
export const d2dReducer = createReducer(
  initState,
  on(updateAvailableProducts, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightProducts: payload }
  })),
  on(updateBookingCount, (state, { payload }) => ({
    ...state,
    bookingCount: payload
  })),
  on(incrementBookingCount, (state) => ({
    ...state,
    bookingCount: state.bookingCount + 1
  })),
  on(updateAddBookingCount, (state, { payload }) => ({
    ...state,
    addBookingCount: payload
  })),
  on(saveFormData, (state, { payload }) => ({
    ...state,
    formData: payload
  })),
  on(saveBookingDetails, (state, { payload }) => {
    const { bookingType, flightReducer, bookingReducer, currentBookingReducer, priceReducer, timeslotReducer, flightFinderReducer, hubDropReducer, isCompleted } = payload;

    const newBooking: IBooking = {
      isCompleted,
      flightReducer,
      bookingReducer,
      currentBookingReducer,
      priceReducer: {
        price: priceReducer.price,
        amendPaymentConfirmed: priceReducer.amendPaymentConfirmed,
      },
      timeslotReducer,
      flightFinderReducer,
      hubDropReducer,
    };

    return {
      ...state,
      [bookingType]: newBooking, // Update the state with the new booking
    };
  }),
  on(updateInboundBookingObject, (state, { payload }) => ({
    ...state,
    inboundBooking: {
      ...state.inboundBooking,
      currentBookingReducer: {
        ...state.inboundBooking.currentBookingReducer,
        currentBooking: payload
      }
    }
  })),
  on(updateOutboundBookingObject, (state, { payload }) => ({
    ...state,
    outboundBooking: {
      ...state.outboundBooking,
      currentBookingReducer: {
        ...state.outboundBooking.currentBookingReducer,
        currentBooking: payload
      }
    }
  })),
  on(updateInboundAddress, (state, { payload }) => ({
    ...state,
    inboundBooking: {
      ...state.inboundBooking,
      bookingReducer: {
        ...state.inboundBooking.bookingReducer,
        bookingDetails: {
          ...state.inboundBooking.bookingReducer.bookingDetails,
          customerAddress: payload
        }
      }
    }
  })),
  on(updateOutboundAddress, (state, { payload }) => ({
    ...state,
    outboundBooking: {
      ...state.outboundBooking,
      bookingReducer: {
        ...state.outboundBooking.bookingReducer,
        bookingDetails: {
          ...state.outboundBooking.bookingReducer.bookingDetails,
          customerAddress: payload
        }
      }
    }
  })),
  on(updateIsBookingComplete, (state, { payload }) => {
    const { bookingType, isCompleted } = payload;
    let updatedState;
    if (bookingType === 'inboundBooking') {
      updatedState = { ...state, inboundBooking: { ...state.inboundBooking, isCompleted } };
    } else {
      updatedState = { ...state, outboundBooking: { ...state.outboundBooking, isCompleted } };
    }
    return updatedState;
  }),
  on(savePromoCode, (state, { payload }) => ({
    ...state,
    promoCode: payload
  })),
  on(saveOutboundPrice, (state, { payload }) => ({
    ...state,
    outboundPrice: payload
  })),
  on(saveInboundPrice, (state, { payload }) => ({
    ...state,
    inboundPrice: payload
  })),
  on(selectedServiceType, (state, { payload }) => ({
    ...state,
    userSelectedServicetype: payload
  })),
  on(sessionServiceType, (state, { payload }) => ({
    ...state,
    sessionServiceType: payload
  })),
  on(applePayToken, (state, { payload }) => ({
    ...state,
    applePayToken: payload
  })),
  on(googlePayToken, (state, { payload }) => ({
    ...state,
    googlePayToken: payload
  })),
  on(updateSessionRequest, (state, { payload }) => ({
    ...state,
    hasSession: payload.hasSession,
    sessionFlightStatusRequest: payload.request
  })),
  on(canAvailD2d, (state, { payload }) => ({
    ...state,
    canAvailD2d: payload
  })),
  on(paymentWithSavedCard, (state, { payload }) => ({
    ...state,
    paymentWithSavedCard: payload
  })),
  on(cardType, (state, { payload }) => ({
    ...state,
    cardType: payload
  })),
  on(promoDetails, (state, { payload }) => ({
    ...state,
    promoDetails: payload
  })),
  on(updateCurrentBookingProduct, (state, { payload }) => ({
    ...state,
    currentBookingProduct: payload
  })),
  on(refreshD2dBooking, (state, { payload }) => ({
    ...payload
  })),
  on(resetD2dState, () => ({ ...initState })),
  on(paymentType, (state, { payload }) => ({
    ...state,
    paymentType: payload
  })),
  on(savePostOfficePrice, (state, { payload }) => ({
    ...state,
    departurePostOfficePrice: payload
  }))
);

// Helper function for booking count
function bookingCount(inbound, outbound): number {
  let count = 0;
  if (Object.keys(inbound).length > 0) {
    count += 1;
  }
  if (Object.keys(outbound).length > 0) {
    count += 1;
  }
  return count;
}
